<svg *ngIf="isFavorite" (click)="setFavorite()" [attr.aria-label]="removeFavoriteTooltip" 
    class="icon-16 fill-favoriteStar icon-btn favoriteButton" [ngbPopover]="removeFavoriteTooltip" popoverClass="favoritePopover" container="body" 
    placement="bottom-left top-left" triggers="mouseenter:mouseleave" (keydown.enter)="null">
    <use href="../App_Themes/CXone/icons/favorite-star.svg#favorite-star"></use>
</svg>
<svg *ngIf="!isFavorite" (click)="setFavorite()" [attr.aria-label]="addFavoriteTooltip"
    class="icon-16 fill-iconDefault-noHover icon-btn favoriteButton" [ngbPopover]="addFavoriteTooltip" popoverClass="favoritePopover" container="body"
    placement="bottom-left top-left" triggers="mouseenter:mouseleave" (keydown.enter)="null">
    <use href="../App_Themes/CXone/icons/favorite-star-outline.svg#favorite-star-outline"></use>
</svg>
